module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/31233f7f72ad06fc2244f4b19cb9eafe.png";